import { render, staticRenderFns } from "./pic-upload.vue?vue&type=template&id=a5d89898&scoped=true&"
import script from "./pic-upload.vue?vue&type=script&lang=js&"
export * from "./pic-upload.vue?vue&type=script&lang=js&"
import style0 from "./pic-upload.vue?vue&type=style&index=0&id=a5d89898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d89898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/180f2a3c-943f-4c29-bc88-c8fc32933762/workspace/b2b2c_pc_2b_nbgr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5d89898')) {
      api.createRecord('a5d89898', component.options)
    } else {
      api.reload('a5d89898', component.options)
    }
    module.hot.accept("./pic-upload.vue?vue&type=template&id=a5d89898&scoped=true&", function () {
      api.rerender('a5d89898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pic-upload.vue"
export default component.exports